(() => {
  const root = document.querySelector('[data-iv-support]');
  if (!root) return;
  const trigger = root.querySelector('[data-iv-support-open]');
  const drawer = root.querySelector('.iv-support__drawer');
  const backdrop = root.querySelector('.iv-support__backdrop');
  const closeButtons = root.querySelectorAll('[data-iv-support-close]');
  const offerTrigger = root.querySelector('[data-iv-global-offer-open]');
  const offer = root.querySelector('[data-iv-global-offer]');
  const offerCloseButtons = root.querySelectorAll('[data-iv-global-offer-close]');
  let lastFocused = null;

  const updateFloatingTools = () => {
    document.body.classList.add('iv-floating-tools-visible');
  };

  const open = () => {
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    backdrop.hidden = false;
    document.body.classList.add('iv-support-open');
    window.setTimeout(() => root.querySelector('.iv-support__header [data-iv-support-close]')?.focus(), 30);
  };

  const close = () => {
    root.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    backdrop.hidden = true;
    document.body.classList.remove('iv-support-open');
    lastFocused?.focus?.();
  };

  const openOffer = () => {
    if (!offer) return;
    lastFocused = document.activeElement;
    offer.hidden = false;
    document.body.classList.add('iv2-offer-open');
    window.setTimeout(() => offer.querySelector('input, .iv2-offer__close')?.focus(), 30);
  };

  const closeOffer = () => {
    if (!offer) return;
    offer.hidden = true;
    document.body.classList.remove('iv2-offer-open');
    lastFocused?.focus?.();
  };

  trigger.addEventListener('click', open);
  updateFloatingTools();
  offerTrigger?.addEventListener('click', openOffer);
  offerCloseButtons.forEach((button) => button.addEventListener('click', closeOffer));
  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (offer && !offer.hidden && event.key === 'Escape') { closeOffer(); return; }
    if (!root.classList.contains('is-open')) return;
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('button, a[href]')].filter((item) => !item.disabled);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
